export function shouldInjectPreFetchedPeers({
  isPreFetchPeers = false,
  hasInjectedPreFetchedPeers = true,
} = {}) {
  return isPreFetchPeers && !hasInjectedPreFetchedPeers
}
